import React from 'react';
import {Provider} from 'react-redux';
import AppRoute from './navigations/Navigator';
import {Store} from './redux/Store';
import {StatusBar, LogBox} from 'react-native';

export default function App() {
   LogBox.ignoreLogs([
      'ViewPropTypes will be removed',
      'ColorPropType will be removed',
   ]);
   return (
      <>
         <StatusBar barStyle="light-content" hidden={false} />
         <Provider store={Store}>
            <AppRoute />
         </Provider>
      </>
   );
}
